import Vue from "vue";

const monthNames = [
  "янв.",
  "фев.",
  "марта",
  "апр.",
  "мая",
  "июня",
  "июля",
  "авг.",
  "сен.",
  "окт.",
  "ноя.",
  "дек."
];

Vue.filter("simpleDate", function(value) {
  if (!value) return "Нет даты";
  const d = new Date(value);
  return d.toLocaleDateString("ru");
});

Vue.filter("monthDayDate", function(value) {
  if (!value) return "???";
  const d = new Date(value);
  return `${d.getDate()} ${monthNames[d.getMonth()]}`;
});

Vue.filter("monthDayDateString", function(value) {
  if (!value) return "???";
  const d = new Date(value);
  return `${d.getDate()}.${("0" + (d.getMonth() + 1)).slice(-2)}`;
});

Vue.filter("price", function(value) {
  if (!value) return "";
  return Number(value).toLocaleString("ru");
});
